import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Grid } from '@mui/material';
import { InputField } from './InputField';
export function InputFilters({ inputValues, handleInputValueChange, isSubmitting, setFieldValue }) {
    return (_jsx(Stack, { width: '100%', children: _jsx(Grid, { spacing: 2, direction: 'row', container: true, children: inputValues === null || inputValues === void 0 ? void 0 : inputValues.map((paramItem, index) => (_jsx(Grid, { item: true, xs: 6, children: _jsx(InputField, { paramItem: paramItem, handleChange: value => {
                        setFieldValue(paramItem.name, value);
                        handleInputValueChange(index, paramItem.name, value);
                    }, isSubmitting: isSubmitting }) }))) }) }));
}
